import { useState } from "react";
import {
    Badge,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    List,
    ListItem,
    ListItemText,
    Stack,
} from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import dayjs from "dayjs";
import { VentaDraft } from "../hooks/use-venta-draft";

interface Props {
    drafts: VentaDraft[];
    onRestore: (draft: VentaDraft) => void;
    onDelete: (id: string) => void;
}

export default function VentaDraftRestore({ drafts, onRestore, onDelete }: Props) {
    const [open, setOpen] = useState(false);

    if (drafts.length === 0) return null;

    const handleRestore = (draft: VentaDraft) => {
        setOpen(false);
        onRestore(draft);
    };

    const handleDelete = (id: string) => {
        onDelete(id);
        if (drafts.length <= 1) setOpen(false);
    };

    return (
        <>
            <Badge badgeContent={drafts.length} color="warning">
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<RestoreIcon />}
                    onClick={() => setOpen(true)}
                >
                    Borradores
                </Button>
            </Badge>

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Borradores guardados</DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <List disablePadding>
                        {drafts.map(draft => {
                            const primary = [
                                `${draft.itemCount} artículo${draft.itemCount !== 1 ? "s" : ""}`,
                                draft.clienteNombre,
                            ].filter(Boolean).join(" — ");

                            return (
                                <ListItem key={draft.id} divider sx={{ gap: 2 }}>
                                    <ListItemText
                                        primary={primary}
                                        secondary={dayjs(draft.savedAt).format("DD/MM/YYYY HH:mm")}
                                        sx={{ flex: 1, minWidth: 0 }}
                                        primaryTypographyProps={{ noWrap: true }}
                                    />
                                    <Stack direction="row" gap={1} flexShrink={0}>
                                        <Button size="small" variant="contained" onClick={() => handleRestore(draft)}>
                                            Restaurar
                                        </Button>
                                        <Button size="small" variant="outlined" color="error" onClick={() => handleDelete(draft.id)}>
                                            Eliminar
                                        </Button>
                                    </Stack>
                                </ListItem>
                            );
                        })}
                    </List>
                </DialogContent>
            </Dialog>
        </>
    );
}
